import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getCargoTypes } from 'actions/cargoes/types';
import CargoGazettersTable from './CargoEditorTable';

function CargoEditorPage(props) {
    useEffect(() => {
        props.getCargoTypes();
    }, []);

    return (
        <div id='cargo-assigners' className='table-page'>
            <div className='container'>
                <h2>
                    cargo editor
                </h2>
                <CargoGazettersTable />
            </div>
        </div>
    );
}

export default connect(
    null,
    dispatch => bindActionCreators(
        {
            getCargoTypes,
        },
        dispatch,
    ),
)(CargoEditorPage);



// WEBPACK FOOTER //
// ./app/components/Cargoes/Assigners/CargoEditorPage.jsx